interface NamedOrganisation {
  guid: string
  name?: string | null
}

/**
 * Organisations backfilled from a member without a synced profile have no
 * name, so the guid is the only thing left to show.
 */
export const organisationLabel = (organisation: NamedOrganisation): string =>
  organisation.name || organisation.guid
